<template>

  <div class="popup-container" @click.self="$emit('close')">
    <div class="popup">
      <slot></slot>
      <div class="close-button" @click="$emit('close')">X</div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'Popup'
}

</script>

<style lang="scss" scoped>

@import '../styles/main-colors.scss';

  .popup-container {
    position: absolute;
    z-index: 3;
    width: 100vw;
    height: 100vh;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    justify-items: center;
    align-items: center;

    background-color: rgba($background-dark, 0.2);
  }

  .popup {
    position: relative;
    background-color: $background-light;
    border-radius: 1px;

    box-shadow: 0 5px 20px 0 rgba($background-dark, 0.5);
  }

  .close-button {
    position: absolute;
    top: 0;
    right: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Popup.vue